import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useGetMany, useRecordContext } from 'react-admin';
import { Box, CircularProgress, Typography } from '@mui/material';

export const UserContractorNamesField = ({ record: recordProp }) => {
    const recordFromContext = useRecordContext();
    const record = recordProp ?? recordFromContext;
    const contractorIds = useMemo(() => (Array.isArray(record?.contractorIds) ? record.contractorIds.filter(Boolean) : []), [record?.contractorIds]);
    const { data: contractors = [], isPending } = useGetMany('contractor', { ids: contractorIds }, { enabled: contractorIds.length > 0 });

    const namesById = useMemo(() => {
        const byId = new Map();
        (contractors || []).forEach(contractor => {
            if (contractor?.id != null && contractor.name) {
                byId.set(String(contractor.id), contractor.name);
            }
        });
        return byId;
    }, [contractors]);

    const names = contractorIds.map(id => namesById.get(String(id))).filter(Boolean);

    return (
        <Box>
            {isPending && contractorIds.length > 0 ? (
                <CircularProgress color='primary' size={20} />
            ) : (
                <Typography variant='body2'>{names.length > 0 ? names.join(', ') : '—'}</Typography>
            )}
        </Box>
    );
};

UserContractorNamesField.propTypes = {
    record: PropTypes.object,
};
